// 超大图兜底缩放。
//
// 刻意不做常规压缩：图片链路上已经被重编码多次（后台 perturbImages 用 sharp 重编码 →
// 用户保存到相册 → 小红书上传时再压一次），我们再主动压一道就是叠加损失，清晰图会糊。
// 所以只有大到会拖垮上传的图才处理，阈值以下原样上传。
const MAX_EDGE = 3000;              // 长边上限：小红书展示远低于此，超过纯属浪费带宽
const MAX_BYTES = 8 * 1024 * 1024;  // 8MB 以下不动
const QUALITY = 0.92;

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('decode failed')); };
    img.src = url;
  });
}

// 返回处理后的 File；任何一步失败都退回原文件，绝不因为缩放失败挡住上传
export async function shrinkIfHuge(file) {
  try {
    if (!file || !file.type?.startsWith('image/')) return file;
    if (file.type === 'image/gif') return file; // 动图缩放会丢帧
    if (file.size <= MAX_BYTES) {
      // 体积不大就只看尺寸，尺寸也不大就直接走
      const probe = await loadImage(file);
      if (Math.max(probe.width, probe.height) <= MAX_EDGE) return file;
      return await draw(probe, file);
    }
    return await draw(await loadImage(file), file);
  } catch {
    return file;
  }
}

async function draw(img, file) {
  const scale = Math.min(1, MAX_EDGE / Math.max(img.width, img.height));
  const w = Math.round(img.width * scale);
  const h = Math.round(img.height * scale);
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(img, 0, 0, w, h);
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', QUALITY));
  if (!blob || blob.size >= file.size) return file; // 没变小就用原图
  const name = (file.name || 'image').replace(/\.[^.]+$/, '') + '.jpg';
  return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
}
